import { useRef, useState } from 'react';
import { handleTrack } from '../../utils/tracker';
import { Button, ButtonVariants } from '../Atoms/Button';
import { VideoPlayBtn } from '../Icons/videoPlayBtn';

interface IVideoProps {
  webmSrc: string;
  mp4Src: string;
  poster: string;
  videoId: string;
  className?: string;
  videoClasses?: string;
  muted?: boolean;
  autoPlay?: boolean;
  loop?: boolean;
  playBtn?: boolean;
  hasAccessToPlay?: boolean;
  platform?: string;
  showButton?: boolean;
  playsInline?: boolean;
}

export const Video = ({
  webmSrc,
  mp4Src,
  poster,
  videoId,
  className,
  videoClasses,
  muted = false,
  autoPlay = false,
  loop = false,
  playBtn = true,
  hasAccessToPlay = true,
  showButton = false,
  playsInline = false,
  platform,
}: IVideoProps): JSX.Element => {
  const vidRef = useRef<HTMLVideoElement>(null);
  const [controls, setControls] = useState(false);

  const handlePlayVideo = () => {
    if (platform?.toLowerCase() === 'youtube') {
      window.open(mp4Src);
    } else {
      setControls(true);
      vidRef.current?.play();
      vidRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    handleTrack({
      label: `play_video_platform_${platform}`,
      url: mp4Src || webmSrc,
    });
  };

  return (
    <div className="" onClick={() => hasAccessToPlay && handlePlayVideo()}>
      <div
        className={`videoContainer relative w-full mt-2 mb-4 sm:w-full sm:mt-2 sm:mb-0 ${className}`}
      >
        {playBtn && !controls && <VideoPlayBtn />}
        <video
          ref={vidRef}
          id={videoId}
          controls={controls}
          preload="none"
          width="100%"
          poster={poster}
          height="auto"
          muted={muted}
          autoPlay={autoPlay}
          loop={loop}
          playsInline={playsInline}
          className={videoClasses}
        >
          <source src={webmSrc} type="video/webm" />
          <source src={mp4Src} type="video/mp4" />
          Your browser does not support HTML video.
        </video>
      </div>

      {showButton && !controls && (
        <div className="w-full flex bg-white sm:fixed z-10 sm:py-3 bottom-0 left-0 right-0 sm:shadow-lg">
          <Button
            variant={ButtonVariants.bluefilled}
            className="rounded-sm w-full px-12 text-base sm:w-fit mx-auto"
            onClick={() => hasAccessToPlay && handlePlayVideo()}
          >
            Watch now
          </Button>
        </div>
      )}
    </div>
  );
};
